import Autolinker from 'autolinker';

export const animateTop = () => {
  $('html, body').animate({
    scrollTop: 0,
  }, 300);
};

export const snackBarSettings = {
  duration: 3500,
  pos: 'bottom-center',
  customClass: 'c-snackbar',
  showAction: false,
};

export const snackBarErrorSettings = {
  text: 'An error occurred. Sorry for the inconvenience.',
  duration: 15000,
  pos: 'bottom-center',
  customClass: 'c-snackbar c-snackbar--danger',
};

export const showGenericSnackbarError = () => {
  Snackbar.show(snackBarErrorSettings);
};

export const autoLink = (text) => {
  return Autolinker.link(text, {
    email: false,
    phone: false,
    stripPrefix: {
      scheme: false,
      www: false,
    },
  });
};

export const scrollDownToElement = ($el) => {
  const MINIMUM_VISIBLE = 300;
  const SCROLL_TO_PADDING = 50;

  const pageEndPosition = $(window).scrollTop() + $(window).height();
  const elementPosition = $el.offset().top;

  if (pageEndPosition < elementPosition + MINIMUM_VISIBLE) {
    $('html, body').animate({
      scrollTop: elementPosition - SCROLL_TO_PADDING,
    }, 500);
  }
};

export const scrollUpToElement = ($el, { immediate } = {}) => {
  const pageTopPosition = $(window).scrollTop();
  const elementPosition = $el.offset().top;

  if (pageTopPosition > elementPosition) {
    $('html, body').animate({
      scrollTop: elementPosition,
    }, immediate ? 0 : 500);
  }
};

export const scrollToFitElement = ($el, elementDebugName, padding = 50) => {
  if (!$el || !$el.offset()) {
    Rollbar.warning('cant scroll to element, it doesnt exists', { element: elementDebugName });
    return;
  }
  const elementPosition = $el.offset().top;

  $('html, body').animate({
    scrollTop: elementPosition - padding,
  }, 500);
};

/**
 * Scrolls to the first field (in fieldRefs order) that has a validation error.
 * fieldRefs maps an error key to a ref name; the ref may be an element, a component or a v-for array.
 */
export const scrollToFirstInvalidField = (errors, refs, fieldRefs, padding = 50) => {
  const fieldName = Object.keys(fieldRefs).find(name => errors?.[name]);

  if (!fieldName) {
    return;
  }

  const refName = fieldRefs[fieldName];
  const target = [refs[refName]].flat()[0];

  scrollToFitElement($(target?.$el ?? target), refName, padding);
};

export const mapById = (objects) => {
  if (!objects) {
    return {};
  }

  return objects.reduce((mem, item) => {
    mem[item.id] = item;
    return mem;
  }, {});
};

export const sortAlphabetically = (items, getText = (item) => item.label) => {
  return [...items].sort((a, b) => getText(a).localeCompare(getText(b), undefined, { sensitivity: 'base' }));
};

export const generateUniqueId = () => {
  return `${Date.now().toString(36)}_${Math.random().toString(36).substr(2, 9)}`;
};

// convert html text to encode all tags
export const htmlSafe = (unsafeHTML) => {
  const div = document.createElement('div');
  div.innerText = unsafeHTML;
  const safeHTML = div.innerHTML;

  return safeHTML;
};

export const addTrailingZero = number => {
  if (typeof number !== 'number' && typeof number !== 'string') {
    return number;
  }

  const parts = number.toString().split('.');

  if (!parts[1]) {
    return parts[0];
  }

  parts[1] = `${parts[1]}0`.substr(0, 2);

  return `${parts[0]}.${parts[1]}`;
};

export const groupBy = (array, key) => {
  return array.reduce((memo, element) => {
    (memo[element[key]] = memo[element[key]] || []).push(element);
    return memo;
  }, {});
};

/**
 * Return an object only with requested keys
 *
 * @param obj Object
 * @param keys Array<String>
 * @returns Object
 */
export const pick = (obj, keys) => {
  const newObj = {};

  keys.forEach(key => {
    if (obj[key]) {
      newObj[key] = obj[key];
    }
  });

  return newObj;
};

export const jsonEquals = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const parseArrayToHashMap = (array) => {
  const map = {};

  array.forEach(val => {
    map[val] = true;
  });

  return map;
};

export const addHardSpacesToPriceType = (value) => {
  if (!value) return '';

  return value.replace(/ /gmi, '&nbsp;').replace(/&nbsp;\+/gmi, ' +');
};

export const replaceSelection = ({
  sourceText, selectionStart, selectionEnd, textToInsert,
}) => {
  const before = sourceText.substring(0, selectionStart);
  const after = sourceText.substring(selectionEnd);

  return `${before}${textToInsert}${after}`;
};

export const arrayIncludes = (array, needle) => array.indexOf(needle) !== -1;

// source: https://stackoverflow.com/a/26798337
// scrollToX(container, 0, 1500, 'easeInOutSine');
export function scrollToX(container, scrollTargetX, speed, easing, callback) {
  // scrollTargetX: the target scrollX property of the window
  // speed: time in pixels per second
  // easing: easing equation to use

  scrollTargetX = scrollTargetX || 0;
  speed = speed || 2000;
  easing = easing || 'easeOutSine';

  let cancelAnimation = false;

  const scrollX = container.scrollLeft;
  let currentTime = 0;

  // min time .1, max time .8 seconds
  const time = Math.max(0.1, Math.min(Math.abs(scrollX - scrollTargetX) / speed, 0.8));

  // easing equations from https://github.com/danro/easing-js/blob/master/easing.js
  const easingEquations = {
    easeOutSine(pos) {
      return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine(pos) {
      return (-0.5 * (Math.cos(Math.PI * pos) - 1));
    },
  };

  // add animation loop
  function tick() {
    if (cancelAnimation) {
      return;
    }
    currentTime += 1 / 60;

    const p = currentTime / time;
    const t = easingEquations[easing](p);

    if (p < 1) {
      window.requestAnimationFrame(tick);

      container.scrollTo(scrollX + ((scrollTargetX - scrollX) * t), 0);
    } else {
      container.scrollTo(scrollTargetX, 0);
      if (callback) {
        callback();
      }
    }
  }

  // call start to get started
  return {
    start: tick,
    stop: () => {
      cancelAnimation = true;
    },
  };
}

export const nlToBr = (text) => {
  return text.replace(/\n/gmi, '<br/>');
};
